import type {
  ExerciseCandidateRelation,
  ExerciseDraftStatusName,
  ExerciseRequestStatusName,
} from '@steado/admin-contract/exercise-requests';

import type { ToneName } from '@/components/table/tone';

export const STATUS_LABELS: Readonly<Record<ExerciseRequestStatusName, string>> = {
  open: 'Open',
  resolved: 'Resolved',
  rejected: 'Rejected',
};

export const STATUS_TONES: Readonly<Record<ExerciseRequestStatusName, ToneName>> = {
  open: 'warn',
  resolved: 'ok',
  rejected: 'mute',
};

export const DRAFT_LABELS: Readonly<Record<ExerciseDraftStatusName, string>> = {
  none: 'No draft',
  queued: 'Drafting…',
  ready: 'Draft ready',
  failed: 'Draft failed',
};

export const DRAFT_TONES: Readonly<Record<ExerciseDraftStatusName, ToneName>> = {
  none: 'mute',
  queued: 'info',
  ready: 'accent',
  failed: 'err',
};

/** What each candidate's badge says: the model's judgement, or that nobody has judged it. */
export const RELATION_LABELS: Readonly<Record<ExerciseCandidateRelation, string>> = {
  same: 'Same movement',
  variant: 'A variant',
  similar_name: 'Similar name',
  different: 'Different',
};

export const RELATION_TONES: Readonly<Record<ExerciseCandidateRelation, ToneName>> = {
  same: 'ok',
  variant: 'info',
  similar_name: 'mute',
  different: 'mute',
};
